import React from 'react';
import PropTypes from 'prop-types';

import ExportButton from '../ExportButton.jsx';

function ExportCommGross({ selectedRep, selectedYear, selectedMonth }) {
  const url = `/api/commgross/export/${encodeURIComponent(selectedRep)}/${selectedYear}`;
  const queryParams = selectedMonth ? { month: selectedMonth } : {};
  const filename = `commgross-${selectedRep}-${selectedYear}-${selectedMonth || 'all'}.csv`;

  return (
    <ExportButton
      url={url}
      queryParams={queryParams}
      filename={filename}
      disabled={!selectedRep || !selectedYear}
      data-cy="export-commgross-button"
    />
  );
}

ExportCommGross.propTypes = {
  selectedRep: PropTypes.string,
  selectedYear: PropTypes.number,
  selectedMonth: PropTypes.number,
};

export default React.memo(ExportCommGross);
